import authenticated from './http-clients/authenticated'

export default {
  snapshot({ tenantID }) {
    return authenticated({
      url: `/tenants/${tenantID}/reports/snapshot`,
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/reports.js